import axios from 'axios'

const consumers = {
  /**
   * Update Consumer by id (patch)
   *
   * @param {String} id
   * @param {Object} payload
   * @param {String} payload.firstName
   * @param {String} payload.lastName
   * @param {String} payload.languageCode
   * @param {Object} payload.settings
   * @param {String} payload.settings.privacyVersion
   * @param {String} payload.settings.tncVersion
   * @param {String} payload.settings.cookieVersion
   * @param {Boolean} payload.settings.marketingOptIn
   * @returns {Promise<Object>}
   */
  update(id, payload) {
    return axios.post(`/api/account-management/consumers/${id}`, payload)
  },

  /**
   * Delete Consumer by id
   *
   * @param {String} id
   * @returns {Promise<Object>}
   */
  delete(id) {
    return axios.delete(`/api/account-management/consumers/${id}`)
  },

  /**
   * Initiate update of the consumer's phone
   *
   * @param {String} id
   * @param {Object} payload
   * @param {String} payload.mobileNumber
   * @param {String} payload.countryCode
   * @param {String} cardAuthToken
   * @returns {Promise<Object>}
   */
  verifyChannel({ id, payload, cardAuthToken }) {
    const headers = {}

    if (cardAuthToken) {
      headers['X-SRC-CARD-TOKEN'] = cardAuthToken
    }

    return axios.post(`/api/account-management/consumers/${id}/verifyChannel`, payload, { headers })
  },

  /**
   * Validate update of consumer's phone by OTP
   *
   * @param {String} id
   * @param {Object} payload
   * @param {String} payload.verificationId
   * @param {String} payload.otp
   * @returns {Promise<Object>}
   */
  updateChannel({ id, payload, cardAuthToken }) {
    const headers = {}

    if (cardAuthToken) {
      headers['X-SRC-CARD-TOKEN'] = cardAuthToken
    }

    return axios.post(`/api/account-management/consumers/${id}/updateChannel`, payload, { headers })
  }
}

export default consumers
